<div class="not-available-container container" fxFlexFill fxLayout="column" fxLayoutAlign="start center">
  <div class="text-container text-center" fxLayout="column" fxLayoutAlign="start center">
    <fa-icon class="error-icon" icon="exclamation-circle"></fa-icon>
    <h1 class="mat-h1 text-small-caps">{{ 'UH_OH' | translate }}</h1>
    <h2 class="mat-h2">{{ 'SOMETHING_WENT_WRONG' | translate }}</h2>
    <p>{{ 'INSIGHTS_NOT_AVAILABLE' | translate }}</p>
    <span><strong>{{ 'EMAIL' | translate }}:</strong>&nbsp;
      <a href="mailto:support@retailstat.com?subject=Insights%20Not%20Available">
        support&#64;retailstat.com
      </a>
    </span>
  </div>
</div>
